import React from 'react';

const ProductSlide = () => {
	return (
		<div className="common-popup category-pom-modal">
			<div className="common-popup-header d-flex justify-content-between">
				<div className="popup-tilte d-flex align-items-center">
					<h3 className="semibold-16 mb-0">SKT23-A1290</h3>
					<span className="pl-2 gray_dark_02 regular-12">|</span>
					<ul className="list-item-with-dot">
						<li className="regular-1 gray_dark_02">MEN</li>
						<li className="regular-12 gray_dark_02">JACKET</li>
					</ul>
				</div>
				<div className="close-btn">
					<img src="/icons/close.svg" alt="close" />
				</div>
			</div>
			<div className="common-popup-body product-slider-body shadow-1dp">
				<div className="product-slider-section assets-slide-section scroll-y-label">
					<div className="product-information d-flex justify-content-between align-items-start">
						<div className="product-list d-flex">
							<div className="slider-nav d-flex flex-column justify-content-start">
								<div className="nav-single d-flex justify-content-center align-items-center active">
									<img src="/images/sketch-dress.png" width="60px" alt="product" />
								</div>
								<div className="nav-single d-flex justify-content-center align-items-center">
									<img src="/images/sketch-dress.png" width="60px" alt="product" />
								</div>
								<div className="nav-single d-flex justify-content-center align-items-center">
									<img src="/images/sketch-dress.png" width="60px" alt="product" />
								</div>
								<div className="nav-single d-flex justify-content-center align-items-center">
									<img src="/images/sketch-dress.png" width="60px" alt="product" />
								</div>
							</div>
							<div className="pom-product-slider">
								<div className="product-single text-center">
									<img src="/images/sketch-dress.png" alt="product" />
									<div className="download-option">
										<img
											src="/icons/download-gray-dark-02.svg"
											alt=""
											width="24px"
											height="24px"
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="slider-info">
							<div className="product-description">
								<ul>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Sketch No.</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500"> Pocket</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Market</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500"> 123POK</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Category</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500">
											{' '}
											Front pocket from top edgeopening edge
										</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Fitting type</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500">
											Front pocket from top edgeopening.
										</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Rise</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500"> 1.5 CM</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Length</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500"> Jacket</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Inspired from</span>
										<span className="clone">:</span>
										<span className="sub-info gray_dark_01 weight-500"> Men</span>
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Remarks</span>{' '}
										<span className="clone">:</span>
										from top edgeopening
									</li>
									<li className="regular-12 d-flex justify-content-start">
										<span className="subtitle gray_dark_05">Files</span>
										<span className="clone">:</span>
										<div className="sub-info gray_dark_01 weight-500">
											<ul className="psd-file-list">
												<li className="underline "> 2D Cad.ai</li>
												<li className="underline "> Cad File.psd</li>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductSlide;
